/**
 * /frontend/src/features/analytics/api/appointmentAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

const HEAVY_APPOINTMENT_ANALYTICS_TIMEOUT_MS = 90_000;

/**
 * Fetches appointments summary metrics.
 */
export const getAppointmentSummary = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.APPOINTMENTS_SUMMARY,
  { storeId, startDate, endDate },
  token,
  'analytics-appointments-summary',
  { timeoutMs: HEAVY_APPOINTMENT_ANALYTICS_TIMEOUT_MS }
);

/**
 * Fetches appointments trend metrics.
 */
export const getAppointmentTrend = async (request, token, storeId, startDate, endDate, granularity) => getJson(
  request,
  ANALYTICS_ENDPOINTS.APPOINTMENTS_TREND,
  { storeId, startDate, endDate, granularity },
  token,
  'analytics-appointments-trend'
);

/**
 * Fetches popular appointment slots.
 */
export const getAppointmentPopularSlots = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.APPOINTMENTS_POPULAR_SLOTS,
  { storeId, startDate, endDate },
  token,
  'analytics-appointments-popular-slots'
);

/**
 * Fetches appointments grouped by service.
 */
export const getAppointmentByService = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.APPOINTMENTS_BY_SERVICE,
  { storeId, startDate, endDate },
  token,
  'analytics-appointments-by-service',
  { timeoutMs: HEAVY_APPOINTMENT_ANALYTICS_TIMEOUT_MS }
);
